// extracted by mini-css-extract-plugin
module.exports = {"wrap-dots":"Dots_wrap-dots__Q2iks","dot":"Dots_dot__1MNAw","dotTicket":"Dots_dotTicket__34KH8"};